// src/config/gauges/fsc_v3.js

export const fscV3GaugeConfig = {
  maestro: [
    {
      key: "tempProcesoEntrada",
      title: "Temp. Maestro Entrada",
      unit: "°C",
      // Verde: 11-14
      // Amarillo: (8,11) y (14,20)
      // Rojo: 0-8 y 20-200
      ranges: [
        { min: 11, max: 13.99, color: "green" },
        { min: 8, max: 10.99, color: "yellow", openMin: true, openMax: true },  // (8,11)
        { min: 14, max: 19.99, color: "yellow", openMin: true, openMax: true }, // (14,20)
        { min: 0, max: 7.99, color: "red" },
        { min: 20, max: 20000, color: "red" },
      ],
    },
    {
      key: "tempProcesoSalida",
      title: "Temp. Maestro Salida",
      unit: "°C",
      // Verde: 7-9
      // Amarillo: (5,7) y (9,20)
      // Rojo: 0-5 y 20-200
      ranges: [
        { min: 7, max: 8.99, color: "green" },
        { min: 5, max: 6.99, color: "yellow", openMin: true, openMax: true },   // (5,7)
        { min: 9, max: 19.99, color: "yellow", openMin: true, openMax: true },  // (9,20)
        { min: 0, max: 4.99, color: "red" },
        { min: 20, max: 20000, color: "red" },
      ],
    },
  ],

  // ✅ SOLO 4 GAUGES por módulo (M1..M10)
  modulo: (n) => ([
    {
      key: `m${n}TempEvapEntrada`,
      title: `M${n} Temp. Evap Entrada`,
      unit: "°C",
      // Verde: 11-14
      // Amarillo: (8,11) y (14,20)
      // Rojo: 0-8 y 20-500
      ranges: [
        { min: 11, max: 13.99, color: "green" },
        { min: 8, max: 10.99, color: "yellow", openMin: true, openMax: true },  // (8,11)
        { min: 14, max: 19.99, color: "yellow", openMin: true, openMax: true }, // (14,20)
        { min: 0, max: 7.99, color: "red" },
        { min: 20, max: 50000, color: "red" },
      ],
    },
    {
      key: `m${n}TempEvapSalida`,
      title: `M${n} Temp. Evap Salida`,
      unit: "°C",
      // Verde: 7-9
      // Amarillo: (6,7) y (9,20)
      // Rojo: 0-6 y 20-500
      ranges: [
        { min: 7, max: 8.99, color: "green" },
        { min: 6, max: 6.99, color: "yellow", openMin: true, openMax: true },   // (6,7)
        { min: 9, max: 19.99, color: "yellow", openMin: true, openMax: true },  // (9,20)
        { min: 0, max: 5.99, color: "red" },
        { min: 20, max: 50000, color: "red" },
      ],
    },
    {
      key: `m${n}PresDescC1`,
      title: `M${n} Pres. Desc C1`,
      unit: "psi",
      // Verde: 430-500
      // Amarillo: (380,430) y (500,550) Aggaarroo UNICO 
      // Rojo: 0-380 y 550-1000
      ranges: [
        { min: 420, max: 500.99, color: "green" },
        { min: 300, max: 419.99, color: "yellow", openMin: true, openMax: true }, // (380,430)
        { min: 500, max: 549.99, color: "yellow", openMin: true, openMax: true }, // (500,550)
        { min: 0, max: 299.99, color: "red" },
        { min: 550, max: 10000, color: "red" },
      ],
    },
    {
      key: `m${n}PresDescC2`,
      title: `M${n} Pres. Desc C2`,
      unit: "psi",
      ranges: [
         { min: 420, max: 500.99, color: "green" },
        { min: 300, max: 419.99, color: "yellow", openMin: true, openMax: true }, // (380,430)
        { min: 500, max: 549.99, color: "yellow", openMin: true, openMax: true }, // (500,550)
        { min: 0, max: 299.99, color: "red" },
        { min: 550, max: 10000, color: "red" },
      ],
    },
  ]),
};
